"use strict";
(function (){

    var self = Fotobook.clipboard = {

        copyToClipboard_in_progress: false,
        pasteFromClipboard_in_progress: false,

        processHotKeys(event) {
            if (!Fotobook.onlineEditorActive()) {
                return;
            }

            if (event.target && $(event.target).closest("input,textarea,[contenteditable]").length || $(".ui-dialog:visible").length) {
                return;
            }
            if (event.originalEvent.repeat !== false) {
                return;
            }
            switch (event.keyCode) {
                case 46: // DEL
                    $(".tb-deletecont:visible:first").click();
                    break;
                case 67: // c
                    if ((event.ctrlKey || event.metaKey) && !event.shiftKey && !event.altKey) {
                        self.copy();
                    }
                    break;
                case 86: // v
                    if ((event.ctrlKey || event.metaKey) && !event.shiftKey && !event.altKey) {
                        self.paste();
                    }
                    break;
            }
        },

        getPastePosition: function(){
            var $page = Fotobook.book.getClosestPageByPixel(Fotobook.mouse.pageX),
                left, right, rect, r, k;
            if (!$page.length || $page.hasClass("flyleaf-page")) {
                return null;
            }
            r = {
                "page_id": parseInt($page.attr("data-id"), 10),
                "x": Fotobook.mouse.pageX,
                "y": Fotobook.mouse.pageY,
            };

            rect = $page[0].getBoundingClientRect();
            left = rect.left;
            right = rect.right;
            if ($page.hasClass("left")) {
                right += parseFloat($page.css("marginRight"));
            } else if ($page.hasClass("right")) {
                left -= parseFloat($page.css("marginLeft"));
            }

            if (r.x > left && r.x < right) {
                r.x = r.x - left;
            } else {
                r.x = (left + right) / 2 - left;
                r.x += (Math.random() * 0.2 - 0.2) * r.x;
            }
            if (r.y > rect.top && r.y < rect.bottom) {
                r.y = r.y - rect.top;
            } else {
                r.y = (rect.top + rect.bottom) / 2 - rect.top;
                r.y += (Math.random() * 0.2 - 0.2) * r.y;
            }
            k = parseFloat($page.attr("data-page-width")) / $page.width();
            r.x_server = r.x * k;
            r.y_server = r.y * k;
            return r;
        },

        copy: function(){
            var self = this,
                ids = [];

            if (self.copy_in_progress) {
                return;
            }
            $(".top-level.selected").add($(":fotobook-containerEditor")).each(function(){
                var $e = $(this).closest(".top-level:not(.locked)"),
                    id = parseInt($e.attr("data-id"), 10);
                if (id && ids.indexOf(id) === -1) {
                    ids.push(id);
                }
            });
            if (!ids.length) {
                return;
            }
            self.copy_in_progress = true;
            const promise = Fotobook.ajax.postJSON("/editor/clipboard/copy", {
                "data" : {
                    "ids" : ids,
                },
            });

            promise.finally(() => self.copy_in_progress = false).catch(() => null);
            return promise;
        },

        /**
         *
         * @returns {*}
         */
        paste: function(){
            return this.pasteToPoint(this.getPastePosition());
        },

        pasteToPoint : function(center){
            if (!center) {
                Fotobook.notification.showWarning(t("photobook-js-error-cannotPlaceElementsOnFlyleaf"));
                return;
            }

            var $page;

            $page = Fotobook.book.getPageById(center.page_id);
            //блокируем вставку из буфера на не фотообложку
            if (!Fotobook.book.cover.foto_clipart && $page.hasClass("cover")){
                Fotobook.notification.showWarning(t("photobook-js-error-cannotPlaceElementsOnCover"));
                return;
            }

            if (this.pasteFromClipboard_in_progress) {
                return;
            }
            this.pasteFromClipboard_in_progress = true;
            Fotobook.ajax.postJSON("/editor/clipboard/paste", {
                "data" : {
                    "page_id": center.page_id,
                    "x": center.x_server,
                    "y": center.y_server,
                },
            }).then((response) => {
                Fotobook.book.setModified(true);
                Fotobook.book.updateBookFromResponse(response.data);
            }).catch(
                ()=>null
            ).finally(() => {
                this.pasteFromClipboard_in_progress = false;
            });
        },
    };
    $(document).on('keydown', self.processHotKeys);
})();
